import { CheckCircleOutline, DoDisturbOn, Label } from "@mui/icons-material";
import {
    Button,
    Container,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import {
    adderReset,
    GetAllAdders,
    GetSingleAdderMethod,
    UpdateAdderMethod,
    UpdateAdderStatus,
} from "../../Redux/AddersSlice/AddersSlice";

const EditAdder = () => {
    const { id } = useParams();

    const { adder, isLoading, isError, errors, isSuccess } = useSelector(
        (state) => state.adders
    );

    const AdderVal = adder?.data || [];

    const dispatch = useDispatch();

    const CallNotificationMethod = async () => {
        toast.success("The data has been modified successfully");
        await dispatch(adderReset());
    };

    const formik = useFormik({
        initialValues: {
            id: "",
            name: "",
            service_type: "",
            status: 0,
        },
        onSubmit: async (values) => {
            await dispatch(UpdateAdderMethod(values));
            await CallNotificationMethod();
        },
    });

    const allServices = [
        { name: "Solar" },
        { name: "Roofing" },
        { name: "Hvac" },
    ];

    useEffect(() => {
        const GetAdderData = async () => {
            await dispatch(GetSingleAdderMethod(id));
            await dispatch(adderReset());
        };
        GetAdderData();
    }, [dispatch, id]);

    useEffect(() => {
        if (AdderVal) {
            formik.values.id = AdderVal?.id || "";
            formik.values.name = AdderVal?.name || "";
            formik.values.service_type = AdderVal?.service_type || "";
            formik.values.status = AdderVal?.status || 0;
        }
    }, [AdderVal]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                if (errors.length < 8) {
                    Object.keys(errors).forEach((key) => {
                        let error = errors[key][0];
                        toast.error(error);
                    });
                } else {
                    toast.error(errors);
                }
            }
            const reset = async () => {
                await dispatch(adderReset());
            };
            reset();
        }
    }, [isError]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <>
                    <Container>
                        <FormHeading> Edit Adder </FormHeading>
                        <form onSubmit={formik.handleSubmit}>
                            <Grid mt={2} container columns={12} spacing={2}>
                                <Grid item mb={1} xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">
                                            Service Type
                                        </InputLabel>
                                        <Select
                                            id="service_type"
                                            name="service_type"
                                            label="Service Type"
                                            value={formik.values.service_type}
                                            onChange={formik.handleChange}
                                        >
                                            {allServices?.map((key, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={key.name}
                                                >
                                                    {key.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item mb={1} xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        id="name"
                                        name="name"
                                        label="Name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item mt={2} pt={1} xs={12} md={6}>
                                    <Grid container>
                                        <Grid item mb={1} xs={12} md={6}>
                                            <Typography variant="lable">
                                                Status :
                                            </Typography>
                                            {parseInt(formik.values?.status) !==
                                            0 ? (
                                                <span indicatorColor="success">
                                                    Active
                                                </span>
                                            ) : (
                                                <span indicatorColor="error">
                                                    Inactive
                                                </span>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <PrimaryButton fullWidth type="submit">
                                {isLoading ? "Loading..." : "Edit"}
                            </PrimaryButton>
                        </form>
                    </Container>
                </>
            )}
        </>
    );
};

export default EditAdder;
